var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reserve position-relative d-flex flex-flow-column align-items-center"},[_c('img',{staticClass:"title",attrs:{"src":require("../../assets/img/reserve/title.png"),"alt":"","srcset":""}}),_vm._v(" "),(_vm.preview < 50000)?_c('div',{staticClass:"defaultImg progress-size"}):_c('div',_vm._l((_vm.previewList),function(value,fKey){return _c('div',{key:fKey,staticClass:"mt-12"},[_c('div',{staticClass:"progress-size",class:[
          'item' + (fKey + 1),
          _vm.preview >= value &&
          (fKey + 1 === _vm.previewList.length || _vm.preview < _vm.previewList[fKey + 1])
            ? 'pimg-block'
            : 'pimg-none'
        ]})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c389312","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainComponents/reserve.vue
// module id = null
// module chunks = 